import { createFileRoute, Link } from '@tanstack/react-router'
import { Wallet, FolderTree, ArrowLeftRight, Receipt, Coins, ArrowRightLeft } from 'lucide-react'

export const Route = createFileRoute('/_authenticated/finance/' as never)({
  component: FinanceIndexPage,
})

const financeModules = [
  {
    title: '账户管理',
    description: '管理公司银行账户和现金账户',
    icon: Wallet,
    href: '/finance/accounts',
    color: 'bg-blue-500',
  },
  {
    title: '分类管理',
    description: '管理收入和支出分类',
    icon: FolderTree,
    href: '/finance/categories',
    color: 'bg-purple-500',
  },
  {
    title: '现金流管理',
    description: '记录和管理公司收支',
    icon: ArrowLeftRight,
    href: '/finance/cash-flows',
    color: 'bg-green-500',
  },
  {
    title: '报销管理',
    description: '管理报销申请和审批',
    icon: Receipt,
    href: '/finance/reimbursements',
    color: 'bg-orange-500',
  },
  {
    title: '换汇转账',
    description: '跨币种账户转账记录',
    icon: ArrowRightLeft,
    href: '/finance/transfers',
    color: 'bg-teal-500',
  },
  {
    title: '币种管理',
    description: '管理系统支持的货币',
    icon: Coins,
    href: '/finance/currencies',
    color: 'bg-amber-500',
  },
]

function FinanceIndexPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold tracking-tight">财务管理</h1>
        <p className="text-muted-foreground">管理公司财务相关功能</p>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-4">
        {financeModules.map((module) => (
          /* @ts-expect-error - TanStack Router type inference issue with dynamic paths */
          <Link
            key={module.href}
            to={module.href}
            className="group rounded-lg border bg-card p-6 transition-colors hover:bg-muted/50"
          >
            <div
              className={`mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg ${module.color}`}
            >
              <module.icon className="h-6 w-6 text-white" />
            </div>
            <h3 className="mb-1 font-semibold group-hover:text-primary">{module.title}</h3>
            <p className="text-sm text-muted-foreground">{module.description}</p>
          </Link>
        ))}
      </div>
    </div>
  )
}
